module.exports = __webpack_public_path__ + "img/wallet.19799654.png";